"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TupleCoder = void 0;
var _abstractCoder = require("./abstract-coder");
var _array = require("./array");
class TupleCoder extends _abstractCoder.Coder {
  constructor(coders, localName) {
    let dynamic = false;
    const types = [];
    coders.forEach(coder => {
      if (coder.dynamic) {
        dynamic = true;
      }
      types.push(coder.type);
    });
    const type = "tuple(" + types.join(",") + ")";
    super("tuple", type, localName, dynamic);
    this.coders = coders;
  }
  encode(writer, value) {
    return (0, _array.pack)(writer, this.coders, value);
  }
  decode(reader) {
    return reader.coerce(this.name, (0, _array.unpack)(reader, this.coders));
  }
}
exports.TupleCoder = TupleCoder;